export default __webpack_public_path__ + "static/media/Nothing.b0bead65.svg";